/// <reference path="../../app.d.ts"/>

import { AppUtils } from '../../../../../shared/utils/index';
import { User } from '../../../../../shared/models/api/User/User';
import { BasicUserService } from '../../../../../shared/services/BasicUserService';
import { BasicApplicationRouter } from '../../../../../shared/services/BasicApplicationRouter';
import { BasicApplicationService } from '../../../../../shared/services/BasicApplicationService';
import { AppApiService } from '../services/AppApiService';
import { AppPersistenceService } from '../services/AppPersistenceService';
import { ApplicationPages } from '../../Constants';
import { defaults } from '../defaults';

import { OverviewPageController } from './steps/OverviewPageController';
import { InputPageController } from './steps/InputPageController';

export class App implements AppController {
	private readonly appPersistanceService: AppPersistenceService;
	private readonly userService: BasicUserService;
	private readonly $ctx: JQuery;
	private readonly options: BasicAppOptions<LocalAppDefinition>;
	private readonly loader: BasicLoader<LocalAppDefinition>;
	private readonly applicationRouter: BasicApplicationRouter<LocalAppDefinition>;
	private readonly applicationService: BasicApplicationService<LocalAppDefinition>;
	private readonly appApiService: AppApiService;
	private stepController: StepController;


	constructor(element: HTMLElement | JQuery, options: BasicAppOptions<LocalAppDefinition>, loader: BasicLoader<LocalAppDefinition>) {
		this.loader = loader;
		this.options = $.extend(true, {}, defaults, options);
		this.$ctx = this.options.$ctx;
		this.userService = new BasicUserService();
		this.applicationRouter = new BasicApplicationRouter(this.options);
		this.appPersistanceService = new AppPersistenceService(this.options);
		this.applicationService = new BasicApplicationService(this.options);
		this.appApiService = new AppApiService(this.options);
	}

	public start(): void {
		this.callDependencyLoader();
	}

	public callDependencyLoader(): void {
		this.loader._loadDependencies(this.initApplication.bind(this));
	}

	public initApplication(): void {
		AppUtils.View.startLoader();
		this.appPersistanceService.prepareApplicationSession();
		this.setVorgangsnummer();

		this.userService.getUser((user: User) => {
			if (this.checkPreconditions(user)) {
				if (this.applicationService.isStep(1)) {
					const inputOptions = this.applicationService.preparePageOptions(ApplicationPages.InputPage);
					this.stepController = new InputPageController(this, inputOptions, this.loader, user);
				}
				else {
					const inputOptions = this.applicationService.preparePageOptions(ApplicationPages.OverviewPage);
					this.stepController = new OverviewPageController(this, inputOptions, this.loader, user);
				}

				this.stepController.start();
			}
			else {
				this.applicationRouter.login();
			}
		});
	}

	public afterRenderApp(): void {
		this.loader.initAdditionalModules(this.$ctx);
		AppUtils.View.stopLoader();
		this.loader.complete();
	}

	private checkPreconditions(user: User): boolean {
		this.appApiService.checkOnlineCustomer((data: ApiResponse<any>) => {
			if (data.Data.istReinerOnlineKunde === true) {
				T.Utils.Helper.routeToUrl(this.options.app.forwardingurlonlinecustomer);
				return false;
			}
			return user.Valid;
		}, () => {
			return user.Valid;
		});
		return user.Valid;
	}

	private setVorgangsnummer(): void {
		const applicationModel = this.appPersistanceService.getApplicationModel();
		if (applicationModel.Vorgangsnummer === undefined) {
			this.appApiService.getVorgangsnummer('DsgvoReport',
				(data: ApiResponse<string>) => {
					applicationModel.Vorgangsnummer = data.Data;
					this.appPersistanceService.setApplicationModel(applicationModel);
				}, () => {
					T.Utils.Helper.routeToUrl(this.options.app.errorurl);
				});
		}
	}
}